import React from "react";
import styles from "./styles/volume-slider.module.scss";
import Image from "next/image";
import volumeOff from "@/assets/music-player/volume-off.svg";
import volumeOn from "@/assets/music-player/volume-on.svg";

interface VolumeSliderProps {
  toggleMute: () => void;
  isMuted: boolean;
  volumeProgressRef: React.RefObject<HTMLInputElement>;
  changeVolume(volumeLevel: number): void;
}

const VolumeSlider = ({
  toggleMute,
  isMuted,
  volumeProgressRef,
  changeVolume,
}: VolumeSliderProps) => {
  return (
    <div className={styles.volume_container}>
      <Image
        className={styles.volume_icon}
        onClick={toggleMute}
        src={isMuted ? volumeOff : volumeOn}
        alt="volume"
      />
      <input
        ref={volumeProgressRef}
        defaultValue="1"
        className={styles.volume_slider}
        type="range"
        step="0.01"
        min="0"
        max="1"
        onChange={(e) => changeVolume(Number(e.target.value))}
      />
    </div>
  );
};

export default VolumeSlider;
